module.exports = __webpack_public_path__ + "img/alters.d8d19860.jpg";